import { render, staticRenderFns } from "./rejectedDialog.vue?vue&type=template&id=311d8abe&scoped=true"
import script from "./rejectedDialog.vue?vue&type=script&lang=js"
export * from "./rejectedDialog.vue?vue&type=script&lang=js"
import style0 from "./rejectedDialog.vue?vue&type=style&index=0&id=311d8abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311d8abe",
  null
  
)

export default component.exports